module.exports = __webpack_public_path__ + "assets/img/slogan-57fd96a7.png";